import { atom } from "recoil";

const listPriceAtom = atom({
	key: "listPriceAtom",
	default: [],
});

export default listPriceAtom;
